import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import "./navbar.css";
import Logo from "../../assets/images/mtg-logo-6.png"
import { FaChevronDown } from 'react-icons/fa6';

const Navbar = ({ direction, ...args }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const mobileMenuRef = useRef(null);
    const [marketplaceOpen, setMarketplaceOpen] = useState(false);
    const [resourcesOpen, setResourcesOpen] = useState(false);
    const marketplaceTimeout = useRef(null);
    const resourcesTimeout = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && !event.target.closest('button[aria-label="menu"]')) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const toggleMenu = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 75);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleMouseEnter = (setMenuOpen, timeoutRef) => {
        clearTimeout(timeoutRef.current);
        setMenuOpen(true);
    };

    const handleMouseLeave = (setMenuOpen, timeoutRef) => {
        timeoutRef.current = setTimeout(() => {
            setMenuOpen(false);
        }, 300); // 300ms gecikme
    };

    return (
        <nav className={`navbar-container flex justify-around items-center relative navbar ${isScrolled ? 'fixed top-0 left-0 w-full z-50' : ''}`}>
            <div className='md:grid grid-cols-5 md:w-full items-center justify-around navbar-container2'>
                <div className="text-white text-xl flex justify-center navbar-logo-container">
                    <div className="logoBox flex items-center">
                        <Link className="flex items-center justify-center" to="/">
                            <img src={Logo} alt="Logo" className="navbar-logo" />
                        </Link>
                    </div>
                </div>
                <div className="navbar-link-container col-span-3 hidden md:flex justify-center gap-12">
                    <Link className="navbar-link" to="/coming-soon">About Us</Link>
                    

                    <div
                        className="relative"
                        onMouseEnter={() => handleMouseEnter(setMarketplaceOpen, marketplaceTimeout)}
                        onMouseLeave={() => handleMouseLeave(setMarketplaceOpen, marketplaceTimeout)}
                    >
                        <Link className="navbar-link cursor-pointer">Services<FaChevronDown /></Link>
                        {marketplaceOpen && (
                            <div className="absolute left-0 mt-2 bg-white shadow-md rounded-xl w-max">
                                {/* <Link to="/marketplace/products" className="block px-4 py-2 text-gray-800 hover:bg-gray-200">Products Marketplace</Link> */}
                                <Link to="/coming-soon" className="block rounded-t-xl px-4 py-2 text-gray-800 hover:bg-gray-200">Our Technology</Link>
                                <Link to="/coming-soon" className="block rounded-b-xl px-4 py-2 text-gray-800 hover:bg-gray-200">Enviromental Commitment</Link>
                            </div>
                        )}
                    </div>

                    {/* <div
                        className="relative"
                        onMouseEnter={() => handleMouseEnter(setResourcesOpen, resourcesTimeout)}
                        onMouseLeave={() => handleMouseLeave(setResourcesOpen, resourcesTimeout)}
                    >
                        <Link className="navbar-link cursor-pointer">Resources <FaChevronDown /></Link>
                        {resourcesOpen && (
                            <div className="absolute left-0 mt-2 bg-white shadow-md rounded-xl w-48">
                                <Link to="/resources" className="block rounded-t-xl px-4 py-2 text-gray-800 hover:bg-gray-200">Resources</Link>
                                <Link to="/resources/how-it-works" className="block px-4 py-2 text-gray-800 hover:bg-gray-200">How It Works</Link>
                                <Link to="/resources/faq" className="block rounded-b-xl px-4 py-2 text-gray-800 hover:bg-gray-200">FAQs</Link>
                            </div>
                        )}
                    </div> */}

                    <Link className="navbar-link" to="/coming-soon">News & Updates</Link>
                    <Link className="navbar-link" to="/coming-soon">Careers</Link>
                </div>
                <div className='flex justify-center items-center gap-2 language-dropdown-container'>
                    <Link className="navbar-try-link" id='navbar-try-button' to="/coming-soon">Contact Us</Link>
                    {/* <Link className="navbar-try-link2" id='navbar-try-button' to="/login">Login</Link> */}
                </div>
            </div>

            <div className="md:hidden flex gap-2">
                <button onClick={toggleMenu} className="navbar-mobile-button text-white focus:outline-none" aria-label="menu">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </button>
            </div>

            {isOpen && (
                <div ref={mobileMenuRef} className="absolute top-[80px] p-4 flex flex-col bg-[#A6C1EE] text-white space-y-2 md:hidden mobile-navbar-page">
                    <Link onClick={() => setIsOpen(false)} to="/coming-soon">About Us</Link>
                    <Link onClick={() => setIsOpen(false)} to="/coming-soon">Marketplace</Link>
                    <Link onClick={() => setIsOpen(false)} to="/coming-soon">Investment Opportunities</Link>
                    <Link onClick={() => setIsOpen(false)} to="/coming-soon">Resources</Link>
                    {/* <Link onClick={() => setIsOpen(false)} to="/partnerships">Partnerships</Link> */}
                    <Link onClick={() => setIsOpen(false)} className="navbar-try-link" id='navbar-try-button-mobile' to="/coming-soon">Get In Touch</Link>
                    <Link onClick={() => setIsOpen(false)} className="navbar-try-link" id='navbar-try-button-mobile' to="/coming-soon">Login</Link>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
